import { audienceSegments } from './whoWeServe'
import { competitors } from './compare'
import { MANAGED_SERVICES } from '@gjl/voice/pricing'

/**
 * Single source for the site's primary navigation. Header (desktop dropdowns)
 * and MobileNav (grouped drawer) both render from this, so they cannot drift.
 */

export interface NavLink {
  label: string
  href: string
  description?: string
}

export interface NavGroup {
  label: string
  items: NavLink[]
  footer?: { label: string; href: string }
}

export const solutionsGroup: NavGroup = {
  label: 'Solutions',
  items: [
    {
      label: 'Websites for Music Organizations',
      href: '/services/websites',
      description: 'Designed for your organization, built and run for you',
    },
    {
      label: 'Application & Audition Funnels',
      href: '/services/application-funnels',
      description: 'Music-native applications with payments and review',
    },
    {
      label: 'Email Marketing',
      href: '/services/email-marketing',
      description: 'Newsletters and season campaigns, one audience record',
    },
    {
      label: 'Donor Management',
      href: '/services/donor-management',
      description: 'Free to accept (0% platform fee); recurring giving, receipts, donor records',
    },
    {
      label: 'Ticketing',
      href: '/services/ticketing',
      description: 'Sell on your own site: 1.5% per ticket, QR check-in',
    },
    {
      label: 'Ongoing Partnership',
      href: '/services/digital-partnership',
      description: 'We keep running it with you after launch',
    },
    { label: 'The Platform', href: '/platform', description: 'The system your site runs on' },
  ],
  footer: { label: 'All services', href: '/services' },
}

export const doneForYouGroup: NavGroup = {
  label: 'Done For You',
  items: [
    ...MANAGED_SERVICES.map((svc) => ({
      label: svc.name,
      href: `/services/done-for-you#${svc.id}`,
    })),
    {
      label: 'Concierge',
      href: '/services/done-for-you#concierge',
      description: 'Everything done for you, plus strategy',
    },
    {
      label: 'Consulting',
      href: '/packages#consulting',
      description: 'Strategy intensives and fractional digital direction',
    },
  ],
  footer: { label: 'All done-for-you services', href: '/services/done-for-you' },
}

export const whoWeServeGroup: NavGroup = {
  label: 'Who We Serve',
  items: audienceSegments.map((segment) => ({
    label: segment.name,
    href: `/who-we-help/${segment.slug}`,
  })),
  footer: { label: 'Everyone we help', href: '/who-we-help' },
}

export const compareGroup: NavGroup = {
  label: 'Compare',
  items: competitors.map((competitor) => ({
    label: `vs ${competitor.name}`,
    href: `/compare/${competitor.slug}`,
  })),
  footer: { label: 'All comparisons', href: '/compare' },
}

export const resourcesGroup: NavGroup = {
  label: 'Resources',
  items: [
    { label: 'Portfolio', href: '/portfolio' },
    { label: 'Blog & Case Studies', href: '/blog' },
    { label: 'Resource Library', href: '/resources' },
    { label: 'About', href: '/about' },
  ],
}

export const navGroups: NavGroup[] = [solutionsGroup, doneForYouGroup, whoWeServeGroup, compareGroup, resourcesGroup]

/** Top-level links that are not dropdowns. */
export const pricingLink: NavLink = { label: 'Pricing', href: '/packages' }
